import {
  type components,
  type operations,
  type paths,
} from '@depop/types-presentation-default-snowdon-api';

import { type DeepOmitLegacyCategoryFields } from './types';

export type Product = DeepOmitLegacyCategoryFields<
  paths['/presentation/api/v1/users/me/recommendations/products/feed/']['get']['responses']['200']['content']['application/json']['objects'][number]
>;

export type ProductById = DeepOmitLegacyCategoryFields<
  paths['/presentation/api/v1/products/{id}/']['get']['responses']['200']['content']['application/json']
>;

export type GetProductListingBySlugResponse =
  operations['products.v1.getProductListingBySlugForEdit']['responses']['200']['content']['application/json'];

export type GetSimilarListingFromProductBySlug =
  operations['products.v1.getSimilarListingFromProductBySlug']['responses']['200']['content']['application/json'];

export type RepopPurchaseResponse =
  paths['/presentation/api/v1/products/repop/by-purchase/{purchaseId}/by-item/{purchaseItemId}/']['get']['responses']['200']['content']['application/json'];

export type RepopPicturesData = RepopPurchaseResponse['pictures_data'];

export type BasedOnRecentViewsRecommendationsProduct =
  paths['/presentation/api/v1/products/recently-viewed/recommendations/products/']['get']['responses']['200']['content']['application/json']['objects'][number];

export type ProductBySlugResponse =
  paths['/presentation/api/v1/products/by-slug/{slug}/']['get']['responses']['200']['content']['application/json'];

export type MoreItemsResponse =
  paths['/presentation/api/v1/products/{id}/more-items/']['get']['responses']['200']['content']['application/json'];

export type MoreItemsProduct = MoreItemsResponse['objects'][number];

export type MoreItemsQuery = NonNullable<
  paths['/presentation/api/v1/products/{id}/more-items/']['get']['parameters']['query']
>;

export type ProductBySlugExtendedResponse =
  paths['/presentation/api/v1/products/by-slug/{slug}/extended/']['get']['responses']['200']['content']['application/json'];

export type ProductExtendedSizes = ProductBySlugExtendedResponse['sizes'];

export type ProductOfferStatus = NonNullable<
  ProductBySlugExtendedResponse['offer']
>['offer_status'];

export type ShippingDiscounts = components['schemas']['ShippingDiscounts'];

export type ShippingDiscountType = NonNullable<
  ShippingDiscounts['national_shipping']
>['discount_type'];

export const ShippingDiscountType = {
  FREE_SHIPPING: 'FREE_SHIPPING',
  SHIPPING_CAMPAIGN: 'SHIPPING_CAMPAIGN',
  VALUE: 'VALUE',
} as const satisfies Record<ShippingDiscountType, ShippingDiscountType>;

export type ShippingConfidence = components['schemas']['ShippingConfidence'];

export type GetProductBySKUResponse =
  paths['/presentation/api/v1/products/by-sku/{sku}/']['get']['responses']['200']['content']['application/json'];
